import { useEffect, useState } from 'react';

import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import { AppWatch } from '@wajeez/wajeez.microservices';
import { groupBy } from '@wajeez-web/core/utils';
import moment from 'moment';
import { SubscriptionDuration } from '@wajeez/wajeez.microservices/dist/api.AppWatch.clients';

const DailyAquiredPremiumUsersCharts = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const { dailyAquiredPremiumUsers, dailyAquiredPremiumUsersStatus } =
    useAppwatchSelector((c) => c.paymentAnalysis);
  const [subscriptionDuration, setSubscriptionDuration] =
    useState<AppWatch.SubscriptionDuration | null>(null);
  const [subscriptionType, setSubscriptionType] = useState<
    AppWatch.SubscriptionType | undefined
  >(undefined);

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getDailyAquiredPremiumUsersAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        SubscriptionDuration: subscriptionDuration,
        SubscriptionType: subscriptionType,
      })
    );
  }, [subscriptionDuration, subscriptionType, dates]);

  return (
    <div className="col-span-2 ">
      {' '}
      <Card>
        <div className="space-y-2">
          <ChartHeader
            title="Daily aquired premium users"
            SubscriptionDurationAction={(duration) =>
              setSubscriptionDuration(duration)
            }
            SubscriptionTypeAction={(type) => setSubscriptionType(type)}
            dates={dates}
            subTitle={
              dailyAquiredPremiumUsers?.sum &&
              dailyAquiredPremiumUsersStatus !== 'loading'
                ? `المجموع: ${dailyAquiredPremiumUsers?.sum}`
                : ''
            }
          />

          <ChartDisplay
            loading={dailyAquiredPremiumUsersStatus === 'loading'}
            formatter={(value, time) => {
              return (
                moment.utc(value).local().locale('en').format('DD/MM/YYYY') ||
                value
              );
            }}
            xAxistype="datetime"
            chartType="area"
            seriesData={[
              {
                type: 'area',
                name: 'Users',
                data:
                subscriptionDuration == null 
                    ? groupBy(
                        dailyAquiredPremiumUsers?.days ?? [],
                        (d) => d.startDate ?? ''
                      ).map((f) => ({
                        x: f.key,
                        y: f.data.reduce((a, b) => a + (b.count ?? 0), 0),
                      }))
                    : (dailyAquiredPremiumUsers?.days ?? []).map((d) => ({
                        x: d.startDate,
                        y: d.count || '',
                      })),
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyAquiredPremiumUsersCharts;
